import { authenticatedAjax, REQUEST } from "../../../../config/ajax-wrapper";
import { AnyAction } from "redux";
import fileDownload from "js-file-download";
import {
    GENERAR_CONSULTA_NOVEDADES_RECIBIDAS_FTP,
    EXITO_CONSULTA_NOVEDADES_RECIBIDAS_FTP,
    ERROR_CONSULTA_NOVEDADES_RECIBIDAS_FTP,
    ERROR_AUTORIZACION,
    LIMPIAR_MENSAJES_ESTADO,
    DESCARGAR_PLANTILLA_MASIVO_ESTADO,
    DESCARGAR_PLANTILLA_MASIVO_ESTADO_EXITO,
    DESCARGAR_PLANTILLA_MASIVO_ESTADO_ERROR,
    exitoConsultaNovedadesRecibidasFtp,
    errorConsultaNovedadesRecibidasFtp,
    descargarPlantillaMasivoEstadoExito,
    descargarPlantillaMasivoEstadoError,
    errorAutorizacion
} from './consultaNovedadesRecibidasActions';


export const generarConsultaNovedadesRecibidasFtpEpic = action$ =>
    action$.ofType(GENERAR_CONSULTA_NOVEDADES_RECIBIDAS_FTP)
        .mergeMap((action: any) => {

            const url = `sat/consultar-novedades-recibidas/generar-ftp`;

            return authenticatedAjax
                .post(
                    url,
                    action.filtro,
                    { 'Content-Type': 'application/json', 'proceso': 'GENERAR_CONSULTA_RECIBO_FTP' }
                )
                .map(response => {
                    const respuesta = response.response.datos;
                    return exitoConsultaNovedadesRecibidasFtp(respuesta.registrosEncontrados, respuesta.registrosParametro, respuesta.correos);
                }).catch(response => {
                    if (response.status === 401 || response.status === 403) {
                        return [errorAutorizacion()];
                    } else {
                        const respuesta = response.response;
                        const mensajeRespuesta = (response.response && respuesta.mensajeRespuesta) ? respuesta.mensajeRespuesta : "Error no controlado en la aplicación";
                        return [errorConsultaNovedadesRecibidasFtp(mensajeRespuesta)];
                    }
                });
        });

export const descargarPlantillaMasivoEstadoEpic = action$ =>
    action$.ofType(DESCARGAR_PLANTILLA_MASIVO_ESTADO)
        .mergeMap((action: any) => {

            const url = `sat/descargas/plantilla-masivo-cambio-estado`;

            return authenticatedAjax
                .getBlob(url)
                .map((response) => {
                    const data = response.response;
                    fileDownload(
                        data,
                        "plantilla_masivo_cambio_estado.xlsx",
                        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                    );
                    return descargarPlantillaMasivoEstadoExito();
                }).catch(response =>
                    [descargarPlantillaMasivoEstadoError()]
                );
        });

export const consultaNovedadesRecibidasReducer = (state =
    {
        estadoGenerarConsultaFTP: REQUEST.NONE,
        mensajeUsuario: undefined,
        registrosEncontrados: undefined,
        registrosParametro: undefined,
        correos: undefined
    }, action: AnyAction) => {

    switch (action.type) {
        case GENERAR_CONSULTA_NOVEDADES_RECIBIDAS_FTP:
            return {
                ...state,
                estadoGenerarConsultaFTP: REQUEST.PENDING
            };
        case EXITO_CONSULTA_NOVEDADES_RECIBIDAS_FTP:
            return {
                ...state,
                estadoGenerarConsultaFTP: REQUEST.SUCCESS,
                registrosEncontrados: action.registrosEncontrados,
                registrosParametro: action.registrosParametro,
                correos: action.correos
            };
        case ERROR_CONSULTA_NOVEDADES_RECIBIDAS_FTP:
            return {
                ...state,
                estadoGenerarConsultaFTP: REQUEST.ERROR,
                mensajeUsuario: action.mensajeRespuesta
            };
        case ERROR_AUTORIZACION:
            return {
                ...state,
                estadoGenerarConsultaFTP: REQUEST.FORBIDDEN
            };
        case DESCARGAR_PLANTILLA_MASIVO_ESTADO:
        case DESCARGAR_PLANTILLA_MASIVO_ESTADO_EXITO:
        case DESCARGAR_PLANTILLA_MASIVO_ESTADO_ERROR:
            return { ...state };
        case LIMPIAR_MENSAJES_ESTADO:
            return {
                ...state,
                estadoGenerarConsultaFTP: REQUEST.NONE,
                mensajeUsuario: undefined,
                registrosEncontrados: undefined,
                registrosParametro: undefined,
                correos: undefined
            };
        default:
            return state;
    }
};


// WEBPACK FOOTER //
// ./src/co/sura/dominio/sat/recibo_novedades_masivo/modulos/consultaNovedadesRecibidasReducers.ts